import { createApp, defineAsyncComponent } from "vue";
// import Home from './views/Home.vue'; // @todo: this will be removed once top level components are made Golbal
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";
//import '../../common/js/helpers/lodash.js';

import initialiseMiniApp from "../../common/js/helpers/initialiseMiniApp";
// Gpay client-side setup
initialiseMiniApp();

// Global components import
import BaseLottie from "../../common/js/components/BaseLottie.vue";
import TopBar from "../../common/js/components/TopBar.vue";
import StoreStatus from "../../common/js/components/StoreStatus.vue";
import LocationMessageBanner from "../../common/js/components/LocationMessageBanner.vue";
import LoginMessageBanner from "../../common/js/components/LoginMessageBanner.vue";
import OrderTypeTabs from "../../common/js/components/OrderTypeTabs.vue";
import DeliveryTime from "../../common/js/components/DeliveryTime.vue";
import SearchProducts from "../../common/js/components/SearchProducts.vue";
import ReOrder from "../../common/js/components/ReOrder.vue";
import ReOrderItemWise from "../../common/js/components/ReOrderNew.vue";
import TrackOrder from "../../common/js/components/TrackOrder.vue";
import PersonalizedOffers from "../../common/js/components/PersonalizedOffers.vue";
import CheesyRewards from "../../common/js/components/CheesyRewards.vue";
import OrderFilters from "../../common/js/components/OrderFilters.vue";
import HorizontalProductScroll from "../../common/js/components/HorizontalProductScroll.vue";
import VerticalProductScroll from "../../common/js/components/VerticalProductScroll.vue";
import HorizontalBanners from "../../common/js/components/HorizontalBanners.vue";
import YourPizzaProfile from "../../common/js/components/YourPizzaProfile.vue";
import HorizontalBannerWithText from "../../common/js/components/HorizontalBannerWithText.vue";
import PaymentOffer from "../../common/js/components/PaymentOffer.vue";
// import EDVOfferData from "../../common/js/assets/FallbackData/EDVOfferData";
import UpSell from "../../common/js/components/UpSell.vue";
import BottomBar from "../../common/js/components/BottomBar.vue";
import ScrollToTop from "../../common/js/components/ScrollToTop.vue";
import HtmlComponent from "../../common/js/components/HtmlComponent.vue";
import FilterMenuAnchorLinks from "../../common/js/components/FilterMenuAnchorLinks.vue";
import storeInitializer from "../../common/js/store/storeInitializer";
import SearchBottomBar from "../../common/js/components/SearchBottomBar.vue";
import PageHeader from "../../common/js/components/PageHeader.vue";
import FloatingMenu from "../../common/js/components/FloatingMenu.vue";
import FeedbackCard from "../../common/js/components/FeedbackCard.vue";
import DynamicBannerWidget from "../../common/js/components/DynamicBannerWidget.vue";
import SlidingBannerWidget from "../../common/js/components/SlidingBannerWidget.vue";
import HorizontalBannerTopLatest from "../../common/js/components/HorizontalBannerTopLatest.vue";
import NutritionInfoV2 from "../../common/js/components/NutritionInfoV2.vue";
import DynamicApiWidgetNoUi from "../../common/js/components/DynamicApiWidgetNoUi.vue";
import FestiveOfferBanners from "../../common/js/components/FestiveOfferBanners.vue";
import BodyBackgroundComponent from "../../common/js/components/BodyBackgroundComponent.vue";
import DeleteUserAccount from "../../common/js/components/DeleteUserAccount.vue";
import DeliveryTimeMAapDot20 from "../../common/js/components/DeliveryTimeMapDot20.vue";
import DealOffer from "../../common/js/components/DealOffer.vue";
import MegaMilestone from "../../common/js/components/MegaMilestone.vue";
import FullImageCard from "../../common/js/components/FullImageCard.vue";
import HorizontalDynamicBanners from "../../common/js/components/HorizontalDynamicBanners.vue";
import BottomBarV2 from "../../common/js/components/BottomBarV2.vue";
import DominosPromise from "../../common/js/components/DominosPromise.vue";
import EdvHeader from "../../common/js/components/EdvHeader.vue";
import EdvBottomBar from "../../common/js/components/EdvBottomBar.vue";
import NxgTrackOrder from "../../common/js/components/NxgTrackOrder.vue";
import SgOneClickWidget from "../../common/js/components/SgOneClickWidget.vue";
import MenuProducts from "../../common/js/components/MenuProducts.vue";
import LoyaltyWidget from "../../common/js/components/Loyalty/HomeLoyalty/LoyaltyWidget.vue";
import QrOrder from "../../common/js/components/QROrder/QR.vue";

const DynamicAppInstall = defineAsyncComponent(
  () => import("../../common/js/components/DynamicAppInstall.vue"),
);

const DynamicAppBanner = defineAsyncComponent(
  () => import("../../common/js/components/DynamicAppBanner.vue"),
);

const app = createApp({});
app.use(store);

/*
 * Initialize the store state from the localStorage.
 * Like userInfo and lastLocation.
 */
storeInitializer(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded
app.component("VueLottiePlayer", BaseLottie);
app.component("top-bar", TopBar);
app.component("location-message-banner", LocationMessageBanner);
app.component("store-status", StoreStatus);
app.component("login-message-banner", LoginMessageBanner);
app.component("order-type-tabs", OrderTypeTabs);
app.component("delivery-time", DeliveryTime);
app.component("search-products", SearchProducts);
app.component("re-order", ReOrder);
app.component("reorder-itemwise", ReOrderItemWise);
app.component("track-order", TrackOrder);
app.component("ng_track_order", NxgTrackOrder);
app.component("sg-one-click", SgOneClickWidget);
app.component("personalized-offers", PersonalizedOffers);
app.component("horizontal-banner-with-text", HorizontalBannerWithText);
app.component("payment-offer", PaymentOffer);
app.component("order-filters", OrderFilters);
app.component("menu-products", MenuProducts);
app.component("horizontal-product-scroll", HorizontalProductScroll);
app.component("vertical-product-scroll", VerticalProductScroll);
app.component("horizontal-banners", HorizontalBanners);
app.component("up-sell", UpSell);
app.component("your-pizza-profile", YourPizzaProfile);
app.component("cheesy-rewards", CheesyRewards);
app.component("bottom-bar", BottomBar);
app.component("search-bottom-bar", SearchBottomBar);
app.component("scroll-to-top", ScrollToTop);
app.component("html-component", HtmlComponent);
app.component("filter-menu-anchor-links", FilterMenuAnchorLinks);
app.component("page-header", PageHeader);
app.component("floating-menu", FloatingMenu);
app.component("nps-feedback", FeedbackCard);
app.component("dynamic-banner-widget", DynamicBannerWidget);
app.component("sliding-banner-widget", SlidingBannerWidget);
app.component("best-seller-top-10", HorizontalBannerTopLatest);
app.component("nutrition-info", NutritionInfoV2);
app.component("dynamic-api-widget-no-ui", DynamicApiWidgetNoUi);
app.component("festive-offer-banners", FestiveOfferBanners);
app.component("body-background-component", BodyBackgroundComponent);

app.component("dynamic-app-install", DynamicAppInstall);
app.component("dynamic-app-banner", DynamicAppBanner);
app.component(
  "horizontal-banner-with-text-configured",
  HorizontalBannerWithText,
);
app.component("delete-user-account", DeleteUserAccount);
app.component("delivery-time-map", DeliveryTimeMAapDot20);
app.component("deal-offer", DealOffer);
app.component("mega-milestone", MegaMilestone);
app.component("full-image-card", FullImageCard);
app.component("horizontal-dynamic-banners", HorizontalDynamicBanners);
app.component("bottom-tabs", BottomBarV2);
app.component("dominos-promise", DominosPromise);
app.component("edv-header", EdvHeader);
app.component("edv-bottom", EdvBottomBar);
app.component("loyalty-widget", LoyaltyWidget);
app.component("qr-order", QrOrder);

app.mount("#themeDefault");

// @todo : uncomment this...

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
/**
 * 1. Do not download lodash.js instead import that, so it will be updated.
 * 2. inside component if you import any class; will be in TitleCase. camelCase is reserved for internal methods and variables.
 *  for exmaple
 *  (N) import localStorageFunc from "../helpers/localStorageFunc";
 *  (Y) should be import -> LocalStorageFunc from "../helpers/localStorageFunc";
 * 3. in components option: please use like this. All component will always have dash in between. ie. top-bar it can't be topbar.  also mention like below.
 *     {
 *         'top-bar':TopBar
 *     }
 *  4. There should be a key/map to send and recieve listener. for example: in case of getting and setting location:
 *      this.$store.dispatch(KeysMap.LOCATION_DETECT_GEO_LOCATION, {}); instead of this.$store.dispatch("Location/detectGeoLocationPopup", {});
 *  5. Style will be in external file only. no internal styling please.
 *  6. Coditional styling should be avoided. only fetch from the computed props or from the data property
 *  7. Key in a loop should be some_unique_string + index (product.name+index)
 *  8. Do not overuse safeVal. Error debugging won't be easy
 *  9.
 */
